import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BuyerShow = () => {
  const location = useLocation();
  const item = location?.state?.item;

  const Navigate = useNavigate();
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (location?.state === null) {
      Navigate("/admin/dashboard");
    } else {
      setName(location?.state?.name);
      setStatus(location?.state?.status);
    }
  }, []);

  const parsedAdditionalFields = (() => {
    try {
      if (typeof item?.additional_fields === "string") {
        return JSON.parse(item.additional_fields);
      }
      return Array.isArray(item?.additional_fields)
        ? item.additional_fields
        : [];
    } catch (e) {
      console.error("Failed to parse additional_fields:", e);
      return [];
    }
  })();

  let productImages = [];
  try {
    const productNode = item?.product?.[0]?.["product.product_image"];
    if (productNode) {
      const cleanStr = productNode.replace(/\\"/g, '"').replace(/^"|"$/g, "");
      const parsed = JSON.parse(cleanStr);
      if (Array.isArray(parsed)) productImages = parsed;
    }
  } catch (e) {
    console.warn("Error parsing product images:", e);
  }

  return (
    <div className="al">
      <div className="al-head">
        <div>
          <h1 className="al-title">Product Details</h1>
          <p className="al-sub">View this buyer product order.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-idbanner">
        <div className="al-idbanner__icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>
        </div>
        <div>
          <div className="al-idbanner__name">{item?.title || "—"}</div>
          <div className="al-idbanner__sub">{item?.material_color || "—"}</div>
        </div>
        <span className="al-pill" style={{ marginLeft: "auto", background: item?.is_active ? "var(--color-success-bg)" : "var(--color-surface-2)", color: item?.is_active ? "var(--color-success-text)" : "var(--color-text-secondary)" }}>
          {item?.is_active ? "Active" : "Deactive"}
        </span>
      </div>

      <div className="al-card">
        <div className="al-cardhead">
          <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg></div>
          <h3 className="al-cardhead__title">Specification</h3>
        </div>
        <div className="al-spec">
          <div><div className="al-spec__lbl">Name</div><div className="al-spec__val">{item?.title || "—"}</div></div>
          <div><div className="al-spec__lbl">Size</div><div className="al-spec__val">{item?.size || "—"}</div></div>
          <div><div className="al-spec__lbl">Material Color</div><div className="al-spec__val">{item?.material_color || "—"}</div></div>
          <div><div className="al-spec__lbl">Print Coverage</div><div className="al-spec__val">{item?.print_coverage || "—"}</div></div>
          <div><div className="al-spec__lbl">Quantity</div><div className="al-spec__val">{item?.quantity || "—"}</div></div>
          <div><div className="al-spec__lbl">Lamination</div><div className="al-spec__val">{item?.product?.lamination || item?.lamination || "—"}</div></div>
          <div><div className="al-spec__lbl">Paper GSM</div><div className="al-spec__val">{item?.paper_gsm || "—"}</div></div>
          <div><div className="al-spec__lbl">Burst Factor</div><div className="al-spec__val">{item?.product?.burst_factor || item?.burst_factor || "—"}</div></div>
          <div><div className="al-spec__lbl">Order Status</div><div className="al-spec__val">{item?.orderStatus || "—"}</div></div>
          <div><div className="al-spec__lbl">No of Ply</div><div className="al-spec__val">{item?.product?.no_of_ply || item?.no_of_ply || "—"}</div></div>
          <div>
            <div className="al-spec__lbl">Date &amp; Time</div>
            <div className="al-spec__val">
              {new Date(item?.product?.created_at || item?.created_at).toLocaleString("en-GB", {
                day: "2-digit", month: "2-digit", year: "numeric",
                hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
              })}
            </div>
          </div>
          <div>
            <div className="al-spec__lbl">Status</div>
            <div className="al-spec__val">
              <span className="al-pill" style={{ background: item?.is_active ? "var(--color-success-bg)" : "var(--color-surface-2)", color: item?.is_active ? "var(--color-success-text)" : "var(--color-text-secondary)" }}>
                {item?.is_active ? "Active" : "Deactive"}
              </span>
            </div>
          </div>
          <div className="al-spec__full">
            <div className="al-spec__lbl">Product Description</div>
            <div className="al-spec__val">{item?.product_description?.replace(/<[^>]+>/g, "") || "—"}</div>
          </div>

          {parsedAdditionalFields.length > 0 && (
            <div className="al-spec__full">
              <div className="al-spec__lbl">Selected Fields</div>
              <div className="al-spec__val">
                <ul style={{ margin: "4px 0 0", paddingLeft: 18 }}>
                  {parsedAdditionalFields.map((field, i) => (
                    <li key={i}>
                      <strong>{field.label}:</strong>{" "}
                      {Array.isArray(field.value) ? field.value.join(", ") : field.value || "—"}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          <div className="al-spec__full">
            <div className="al-spec__lbl">Product Images</div>
            {productImages.length > 0 ? (
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "6px" }}>
                {productImages.map((img, index) => (
                  <img key={index} src={`${process.env.REACT_APP_IMAGE_URL}${img}`} alt={`Product ${index + 1}`}
                    style={{ width: "100px", height: "100px", borderRadius: "8px", objectFit: "cover", border: "1px solid var(--color-border)" }} />
                ))}
              </div>
            ) : (
              <div className="al-spec__val">No Image found</div>
            )}
          </div>

          <div className="al-spec__full">
            <div className="al-spec__lbl">Media File</div>
            {item?.mediaFiles && item.mediaFiles.length > 0 ? (
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "6px" }}>
                {item.mediaFiles.map((media, index) =>
                  media.media_file ? (
                    <img key={index} src={`${process.env.REACT_APP_IMAGE_URL}${media.media_file}`} alt={`Reference ${index + 1}`}
                      style={{ width: "70px", height: "70px", objectFit: "cover", borderRadius: "8px", border: "1px solid var(--color-border)" }} />
                  ) : (
                    <div key={index} className="al-spec__val">No Image</div>
                  )
                )}
              </div>
            ) : (
              <div className="al-spec__val">No Reference Images Found</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyerShow;
